import { render, staticRenderFns } from "./SeimaPrasymas.vue?vue&type=template&id=74b9da99&scoped=true&"
import script from "./SeimaPrasymas.vue?vue&type=script&lang=js&"
export * from "./SeimaPrasymas.vue?vue&type=script&lang=js&"
import style0 from "./SeimaPrasymas.vue?vue&type=style&index=0&id=74b9da99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b9da99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VFooter,VRow,VSpacer})
